import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import CustomerPaymentMethodID from '@/App/CustomerPaymentMethod/Entity/CustomerPaymentMethodID'
import type {
    CustomerPaymentMethodRawData,
    CardPaymentMethodData,
    PayPalPaymentMethodData,
    PaymentMethodTypeEnum,
} from '@/Shared/AutoGenerated/Main'

/**
 * Icons: https://iconduck.com/sets/svg-credit-card-and-payment-icons
 */
export default class CustomerPaymentMethod {
    constructor(
        public readonly id: CustomerPaymentMethodID,
        public readonly type: PaymentMethodTypeEnum,
        public readonly cardPaymentMethodData: CardPaymentMethodData | null,
        public readonly payPalPaymentMethodData: PayPalPaymentMethodData | null,
    ) {
        ensureNoUndefinedProperties(this)
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(
        entityData: CustomerPaymentMethodRawData,
    ): CustomerPaymentMethod {
        return new CustomerPaymentMethod(
            new CustomerPaymentMethodID(entityData.id),
            entityData.type,
            entityData.cardPaymentMethodData,
            entityData.payPalPaymentMethodData,
        )
    }

    static hydrateMultiple(
        entitiesData: CustomerPaymentMethodRawData[],
    ): CustomerPaymentMethod[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
